import { Label } from "@/components/ui/label";
import { ScannerValue } from "..";
import HARMONIC_PATTERN_FAQS from "./harmonic-pattern.json";
import CROSS_OVER_FAQS from "./cross-over.json";
import MOMENTUM_FAQS from "./momentum.json";
import CHART_PATTERN_FAQS from "./chart-pattern.json";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQs = ({ type }: { type: ScannerValue }) => {
  let faqs: { question: string; answer: string }[] = [];

  switch (type) {
    case ScannerValue.HARMONIC_PATTERN:
      faqs = HARMONIC_PATTERN_FAQS;
      break;
    case ScannerValue.CROSS_OVER:
      faqs = CROSS_OVER_FAQS;
      break;
    case ScannerValue.MOMENTUM:
      faqs = MOMENTUM_FAQS;
      break;
    case ScannerValue.CHART_PATTERN:
      faqs = CHART_PATTERN_FAQS;
      break;
    default:
      faqs = [];
      break;
  }

  return (
    <div>
      <Label className="text-2xl">Frequently asked questions</Label>
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq) => (
          <AccordionItem key={faq.question} value={faq.question}>
            <AccordionTrigger>{faq.question}</AccordionTrigger>
            <AccordionContent>{faq.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
